module.exports = __webpack_public_path__ + "images/lamborghini79545c991c6885fa1b5748221ba896b7.png";